"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var trmvrMeterActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/current");
var trmvrEntriesListActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/list");
var printEntriesListActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/print");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./printEntriesModalStyles.scss");
var DatePicker_1 = require("components/DatePicker");
var types_1 = require("types");
var mapStateToProps = function (state) {
    return {
        trmvrEntries: state.trmvrmeterentries.list,
        createdEntryUuid: state.trmvrmeterentries.current.createdEntryUuid,
        currentTRMVRMeter: state.sokosite.current.trmvrMeter,
        printEntries: state.trmvrmeterentries.print,
        selected: state.trmvrmeterentries.list.selected
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchTRMVREntriesToPrint: function (meterUuid, from, to) {
        return dispatch(printEntriesListActions.fetchRequest(meterUuid, from, to));
    },
    clearTRMVREntriesToPrint: function () {
        return dispatch(printEntriesListActions.clearRequest());
    },
    clearState: function () { return dispatch(trmvrMeterActions.clear()); },
    toggleSelection: function (meterUuid) {
        return dispatch(trmvrEntriesListActions.toggleSelection(meterUuid));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.createdEntryUuid !== nextProps.createdEntryUuid) {
            this.props.clearState();
        }
        return true;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var _a = React.useState(), pdfContent = _a[0], setPdfContent = _a[1];
    var _b = React.useState('output.pdf'), pdfFileName = _b[0], setPdfFileName = _b[1];
    var isTRMeter = props.currentTRMVRMeter && props.currentTRMVRMeter.meterType === 'TRMETER';
    // Resets printEntries.list and toggled selections on page load
    React.useEffect(function () {
        props.clearTRMVREntriesToPrint();
        props.selected.forEach(function (entry) { return props.toggleSelection(entry); });
    }, []);
    // If endDate becomes older than startDate, make them the same date
    React.useEffect(function () {
        if (props.startDate && props.endDate) {
            if (props.endDate < props.startDate)
                props.setEndDate(props.startDate);
        }
    }, [props.startDate]);
    var getMinMaxEntries = function () {
        var entries = props.trmvrEntries.list.map(function (entry) {
            if (entry.date !== undefined) {
                var date = entry.date.toString();
                return parseInt(date, 10);
            }
            return 0;
        });
        var filteredEntries = entries.filter(function (x) { return x !== 0; });
        var earliestEntry = Math.min.apply(Math, entries);
        var lastEntry = Math.max.apply(Math, entries);
        if (props.trmvrEntries.selected.length > 0 &&
            props.startDate &&
            props.endDate) {
            earliestEntry = props.startDate.getTime();
            lastEntry = props.endDate.getTime();
        }
        return { firstEntry: earliestEntry, lastEntry: lastEntry };
    };
    // Gets all entries between the start and end dates from the database
    var fetchEntriesToPrint = function () {
        if (props.currentTRMVRMeter && props.startDate && props.endDate) {
            props.fetchTRMVREntriesToPrint(props.currentTRMVRMeter.trmvrmeter_uuid, moment(props.startDate).format('YYYY-MM-DD').toString(), moment(props.endDate).format('YYYY-MM-DD').toString());
        }
    };
    var calculateTotals = function (entry) {
        var correctTotal = 0;
        var incorrectTotal = 0;
        var observationsTotal = 0;
        var levelTotal = 0;
        var levelAVG = 0;
        entry.map(function (measurement) {
            correctTotal += measurement.value.correct;
            incorrectTotal += measurement.value.wrong;
            observationsTotal =
                observationsTotal +
                    (measurement.value.correct + measurement.value.wrong);
            levelTotal =
                measurement.value.correct /
                    (measurement.value.correct + measurement.value.wrong);
        });
        levelAVG = (correctTotal / observationsTotal) * 100;
        return { correctTotal: correctTotal, incorrectTotal: incorrectTotal, observationsTotal: observationsTotal, levelAVG: levelAVG };
    };
    var pdfRef = (0, react_1.useRef)(null);
    // Executes the PDF printing
    var startDownload = function () {
        var el = pdfRef.current;
        if (el !== null) {
            el.style.display = 'block';
            var newWindow = window.open('');
            if (newWindow !== null) {
                var headElement = newWindow.document.createElement('head');
                var linkElement = newWindow.document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href =
                    'https://fonts.googleapis.com/css2?family=Roboto&display=swap';
                headElement.appendChild(linkElement);
                newWindow.document.body.appendChild(el);
                newWindow.document.title = pdfFileName;
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }
        }
        props.selected.forEach(function (entry) { return props.toggleSelection(entry); });
        props.clearState();
    };
    // Once the range of entries to print have been fetched, this hook
    // listens for the props.printEntries.list changes and appends the appropriate
    // data to the tables for each of the entries in range.
    React.useEffect(function () {
        var pdfTempFileName = "".concat(props.currentTRMVRMeter && "".concat(props.currentTRMVRMeter.name, "_")).concat(props.currentTRMVRMeter && props.currentTRMVRMeter.site_number
            ? "".concat(props.currentTRMVRMeter.site_number, "_")
            : '').concat((0, translation_1.getLocalization)('diaryEntriesView/entries').toLowerCase(), "_").concat(moment(props.startDate)
            .format('YYYY-MM-DD')
            .toString(), "-").concat(moment(props.endDate).format('YYYY-MM-DD').toString(), ".pdf");
        var pdf = props.printEntries.list.map(function (entry) {
            return (React.createElement("div", { id: "pdf-content-container-".concat(entry.uuid), style: {
                    pageBreakAfter: 'always',
                    fontFamily: '"Roboto", sans-serif',
                    fontSize: '12px'
                } },
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        marginBottom: '1rem',
                        // borderBottom: '2px solid black',
                        fontFamily: '"Roboto", sans-serif'
                    }, id: "printentries-table-main-header" },
                    React.createElement("tr", null,
                        React.createElement("td", { style: { fontSize: '1.25rem', fontWeight: 600 } }, isTRMeter
                            ? (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/meter')
                            : (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/mvrmeter')),
                        React.createElement("td", { style: { fontSize: '1.25rem', textAlign: 'right' } },
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/week'), ": ").concat(entry.week_number ? entry.week_number : ''))))),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black',
                        marginBottom: '1rem'
                    }, id: "printentries-table-info-".concat(entry.uuid) },
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/worksite'), ": ")),
                            React.createElement("span", null, "".concat(props.currentTRMVRMeter &&
                                "".concat(props.currentTRMVRMeter.name, " / "), " ").concat(props.currentTRMVRMeter && props.currentTRMVRMeter.site_number
                                ? props.currentTRMVRMeter.site_number
                                : ''))),
                        React.createElement("td", null,
                            React.createElement("span", { style: { fontWeight: 600 } }))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/date'), ": ")),
                            React.createElement("span", null, entry.date ? "".concat(moment(entry.date).format('L')) : ''))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/measurer'), ": ")),
                            React.createElement("span", null, entry.employer_signature
                                ? entry.employer_signature.replace(/[0-9\.\:]/g, '')
                                : '')))),
                React.createElement("table", { id: "printentries-table-observations-".concat(entry.uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderCollapse: 'collapse'
                    } },
                    React.createElement("tr", { style: { borderBottom: '1px solid black' } },
                        React.createElement("th", { style: { fontWeight: 600, textAlign: 'left' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/subject')),
                        React.createElement("th", { style: { fontWeight: 600, textAlign: 'center' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/observation')),
                        React.createElement("th", { style: { fontWeight: 600, textAlign: 'center' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/correct')),
                        React.createElement("th", { style: { fontWeight: 600, textAlign: 'center' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/incorrect')),
                        React.createElement("th", { style: { fontWeight: 600, textAlign: 'center' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/levelInPercentage'))),
                    entry.measurements &&
                        entry.measurements.map(function (measurement) { return (React.createElement("tr", { style: { borderBottom: '1px solid black', height: '2rem' } },
                            React.createElement("td", { style: { fontWeight: 600, textAlign: 'left' } }, (0, translation_1.getLocalization)("TRMVRMeterEntriesView/printEntries/measurements/".concat(measurement.name))),
                            React.createElement("td", { style: { textAlign: 'center' } }, measurement.value.correct + measurement.value.wrong),
                            React.createElement("td", { style: {
                                    textAlign: 'center',
                                    color: 'green',
                                    fontSize: '20px',
                                    fontWeight: 600
                                } }, measurement.value.correct),
                            React.createElement("td", { style: {
                                    textAlign: 'center',
                                    color: 'red',
                                    fontSize: '20px',
                                    fontWeight: 600
                                } }, measurement.value.wrong),
                            React.createElement("td", { style: { textAlign: 'center' } }, ((measurement.value.correct /
                                (measurement.value.correct + measurement.value.wrong)) *
                                100).toFixed(2) + '%'))); }),
                    React.createElement("tr", { style: { height: '2rem' } },
                        React.createElement("td", { style: { textAlign: 'left' } }, (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/measurements/total')),
                        React.createElement("td", { style: { textAlign: 'center' } }, entry.measurements
                            ? calculateTotals(entry.measurements).observationsTotal
                            : ''),
                        React.createElement("td", { style: { textAlign: 'center' } }, entry.measurements
                            ? calculateTotals(entry.measurements).correctTotal
                            : ''),
                        React.createElement("td", { style: { textAlign: 'center' } }, entry.measurements
                            ? calculateTotals(entry.measurements).incorrectTotal
                            : ''))),
                React.createElement("div", { style: {
                        fontWeight: 600,
                        fontSize: '1.5rem',
                        border: '3px solid black',
                        width: '100%',
                        paddingTop: '0.5rem',
                        paddingBottom: '0.5rem',
                        textAlign: 'center'
                    } }, entry.measurements
                    ? "".concat(isTRMeter
                        ? (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/measurements/trlevel')
                        : (0, translation_1.getLocalization)('TRMVRMeterEntriesView/printEntries/measurements/mvrlevel'), ": ").concat(entry.measurements &&
                        calculateTotals(entry.measurements).levelAVG.toFixed(2), "%")
                    : '')));
        });
        setPdfContent(pdf);
        setPdfFileName(pdfTempFileName);
    }, [props.printEntries.list]);
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'diary-entries-modal-print-entries' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.clearTRMVREntriesToPrint();
                props.closeModal();
            } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/header')),
        React.createElement("form", null,
            React.createElement("div", { className: "modal-content-container" }, props.printEntries.status === 'STANDBY' ? (React.createElement("div", { className: "modal-initial-content" },
                React.createElement("h4", null, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/fileformat')),
                React.createElement("div", { className: "inputs-container" },
                    React.createElement(sok_ui_1.Input, { type: "radio", name: "pdfradio", checked: true, label: 'PDF', defaultChecked: true })),
                React.createElement("h4", null, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/timeframe')),
                React.createElement("div", { className: "dates-container" },
                    React.createElement("div", { className: "start-date-container" },
                        React.createElement(DatePicker_1.DatePicker, { selected: moment(props.startDate), minDate: moment(getMinMaxEntries().firstEntry), maxDate: moment(), onChange: function (e) {
                                return props.setStartDate(moment(e).toDate());
                            } })),
                    React.createElement("div", { className: "end-date-container" },
                        React.createElement(DatePicker_1.DatePicker, { selected: moment(props.endDate), minDate: moment(props.startDate), maxDate: moment(), onChange: function (e) {
                                return props.setEndDate(moment(e).toDate());
                            } }))))) : (React.createElement("div", { className: "spinner-container" },
                React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.printEntries.status === 'FETCHING', success: props.printEntries.status === 'FETCHED' }),
                React.createElement("p", null, props.printEntries.status === 'FETCHING'
                    ? (0, translation_1.getLocalization)('diaryEntriesView/printEntries/generatingreport')
                    : (0, translation_1.getLocalization)('diaryEntriesView/printEntries/reportReady')),
                props.printEntries.status === 'FETCHED' && (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/download'), color: 'blue', onClick: startDownload }))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/close'), color: 'dark-gray', disabled: props.printEntries.status === 'FETCHING', onClick: function () {
                        props.clearTRMVREntriesToPrint();
                        props.closeModal();
                    } }),
                props.printEntries.status !== 'FETCHED' && (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/create'), disabled: props.printEntries.status === 'FETCHING', color: 'base-green', onClick: fetchEntriesToPrint })))),
        React.createElement("div", { id: "pdf", ref: pdfRef, style: { display: 'none' } },
            React.createElement("div", { id: "pdf-contents" }, pdfContent && pdfContent))));
});
